import { render } from "./login.vue?vue&type=template&id=d95a1f44&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=d95a1f44&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95a1f44"]])

export default __exports__